import { Box, Divider, List, Typography, useTheme } from "@mui/material";
import MobileHeader from "../../../layout/DriverLayout/Header";
import bigCar2 from "../../../../media/images/icons/bigcar2.svg";
import profileImage from "../../../../media/images/profileImage.svg";
import { useAppSelector } from "../../../../hooks/useRedux";
import CustomListItem from "./ListItem";
import CarTagView from "../../../components/CarTag";
import { grey } from "@mui/material/colors";
import TruckFillSVG from "../../../../media/images/icons/truck-fill";
import ShieldSecuritySVG from "../../../../media/images/icons/shield-security";
import SmsTrackingIcon from "../../../../media/images/icons/sms-tracking";
import TruckCheck from "../../../../media/images/icons/truck-check";
import UserSquerSVG from "../../../../media/images/icons/squer-user";
import logoimage from "../../../../media/images/logos/Logo-Karen.png";
import AuthorizationDriverLabel from "../../../components/AuthorizationDriverLabel";

export default function ProfilePage() {
  const themeMode = useAppSelector((state) => state.settings.themeMode);

  const theme = useTheme();

  const { fullName, mobileNr, nationalCode, vehicleInfo } = useAppSelector(
    (state) => state.user
  );

  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 700,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            حساب کاربری من
          </Typography>
        }
      />
      <Box
        sx={{
          paddingX: "8px",
        }}
      >
        {/**section1 */}
        <Box
          sx={{
            position: "relative",
            marginTop: "32px",
            width: "100%",
            backgroundColor: "bgColor.white",
            padding: "16px",
            borderRadius: "16px",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: -32,
              right: 32,
              // border: "1px solid gray",
              height: "64px",
              width: "64px",
            }}
          >
            <img
              style={{
                borderRadius: "50%",
              }}
              src={profileImage}
              alt=""
            />
          </Box>
          {/* <Box
            sx={{
              zIndex: 32,
              position: "absolute",
              right: 32,
              width: 28,
              height: 28,
              // border: "1px solid gray",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              backgroundColor: "bgColor.white",
            }}
          >
            <EditIcon size={20} color={theme.palette.primary.main} />
          </Box> */}
          {/* <Box sx={{ display: "flex", justifyContent: "end" }}>
            <CustomButton
              // loading={loading}
              // onClick={() => onOk()}
              flexDirection="row"
              title="حذف عکس پروفایل"
              justifyContent="center"
              bgColor="error.light"
              fSize="14px"
              textColor="error.main"
              fWeight="700"
              px="10px"
              py="10px"
              borderRadius="10px"
              icon1={<RubbishSVG color={theme.palette.error.main} size={22} />}
            />
          </Box> */}

          <Box
            sx={{
              marginTop: "32px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                color: theme.palette.secondary[600],
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              {fullName || "-------"}
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "600",
              }}
            >
              {mobileNr || "---------"}
            </Typography>
          </Box>
          <AuthorizationDriverLabel />
          <Box
            sx={{
              marginTop: "8px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <Typography sx={{ fontWeight: "700", fontSize: "14px" }}>
                ‌کد‌ملی:
              </Typography>
              <Typography sx={{ fontWeight: "700", fontSize: "14px" }}>
                {nationalCode || "-------"}
              </Typography>
            </Box>
            <CarTagView />
          </Box>
          <Box
            sx={{
              marginTop: "12px",
              padding: "8px 8px",
              borderRadius: "8px",
              backgroundColor: theme.palette.secondary[50],
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img width={20} src={bigCar2} alt="" />
              <Typography
                sx={{ fontWeight: "700", color: grey[800], fontSize: "14px" }}
              >
                گروه بارگیر
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "14px",
                color: theme.palette.secondary[600],
              }}
            >
              {vehicleInfo?.loaderTypeGroup || "------"}
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "8px",
              padding: "8px 8px",
              borderRadius: "8px",
              backgroundColor: theme.palette.secondary[50],
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img width={20} src={bigCar2} alt="" />
              <Typography
                sx={{ fontWeight: "700", color: grey[800], fontSize: "14px" }}
              >
                نوع بارگیر
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "700",
                color: theme.palette.secondary[600],
                fontSize: "14px",
              }}
            >
              {vehicleInfo?.loaderTypeName || "-------"}
            </Typography>
          </Box>
        </Box>

        {/**section2 */}
        {/* 
        <Box
          sx={{
            marginTop: "16px",
            width: "100%",
            backgroundColor: "bgColor.white",
            padding: "16px",
            borderRadius: "16px",
          }}
        > */}
        <Box
          sx={{
            marginTop: "8px",
            padding: "8px 8px",
            borderRadius: "8px",
            backgroundColor: "bgColor.white",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <TruckFillSVG color={themeMode === "dark" ? "#fff" : grey[800]} />
            <Typography sx={{ fontWeight: "600", fontSize: "14px" }}>
              شماره هوشمند ناوگان:
            </Typography>
          </Box>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "14px",
              color: "secondary.main",
            }}
          >
            {vehicleInfo?.smartCard || "------"}
          </Typography>
        </Box>
        {/* <Box
            sx={{
              marginTop: "8px",
              padding: "8px 8px",
              borderRadius: "8px",
              backgroundColor: theme.palette.bgColor.blueGrey100,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={document} alt="" />
              <Typography sx={{ fontWeight: "600", fontSize: "14px" }}>
                پایان معاینه فنی:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                color: "secondary.main",
              }}
            >
              {"--/--/----"}
            </Typography>
          </Box> */}
        {/* <Box
            sx={{
              marginTop: "8px",
              padding: "8px 8px",
              borderRadius: "8px",
              backgroundColor: theme.palette.bgColor.blueGrey100,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={contact} alt="" />
              <Typography sx={{ fontWeight: "600", fontSize: "14px" }}>
                اعتبار کارت هوشمند راننده:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                color: "secondary.main",
              }}
            >
              {"--/--/----"}
            </Typography>
          </Box> */}
        {/* <Box
            sx={{
              marginTop: "8px",
              padding: "10px 8px",
              borderRadius: "8px",
              backgroundColor: "bgColor.blueGrey100",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img src={profiledark} alt="" />
              <Typography sx={{ fontWeight: "600", fontSize: "14px" }}>
                پایان کارت سلامت:{" "}
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "14px",
                color: "secondary.main",
              }}
            >
              {"--/--/----"}
            </Typography>
          </Box> */}
        {/* </Box> */}
        {/**section 3*/}

        <Box
          sx={{
            marginTop: "16px",
            width: "100%",
            backgroundColor: "bgColor.white",
            borderRadius: "16px",
          }}
        >
          <nav
            style={{
              padding: "0px 8px",
            }}
            aria-label="main mailbox folders"
          >
            <List
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <CustomListItem
                path="../edit-profile"
                title="ویرایش اطلاعات و ارسال مدارک"
                icon={
                  <UserSquerSVG
                    color={themeMode === "light" ? grey[800] : "#fff"}
                  />
                }
              />
              <Divider variant="middle" />
              <CustomListItem
                path="../change-vehicle"
                title="تغییر ناوگان"
                icon={
                  <TruckCheck
                    color={themeMode === "light" ? grey[800] : "#fff"}
                  />
                }
              />
              <Divider variant="middle" />
              <CustomListItem
                path="../change-password"
                title="تغییر رمز عبور"
                icon={
                  <ShieldSecuritySVG
                    color={themeMode === "light" ? grey[800] : "#fff"}
                  />
                }
              />
              <Divider variant="middle" />
              <CustomListItem
                path="../change-mobile"
                title="تغییر شماره همراه"
                icon={
                  <SmsTrackingIcon
                    color={themeMode === "light" ? grey[800] : "#fff"}
                    size={28}
                  />
                }
              />
              <Divider variant="middle" />
              {/* <CustomListItem
                path="../settings"
                title="تنظیمات اطلاع‌رسانی و دسترسی‌ها"
                icon={settingsIcon}
              /> */}
              {/* <Divider variant="middle" /> */}
              <CustomListItem
                path="/aboutus"
                title="درباره کارن ترابر نت"
                icon={
                  <img width={28} src={logoimage} alt="" />
                  // <LogoKarenSVG
                  //   color={themeMode === "light" ? grey[800] : "#fff"}
                  // />
                }
              />
            </List>
          </nav>
        </Box>
      </Box>
    </>
  );
}
